/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any) => ({
  // 청구 내역 조회
  async index(data?: any) {
    return camelize(await $axios.get(`/billing`, snakelize({ params: data })));
  },
});
